import { config } from '~app/config';

import { ampli } from '~entities/ampli';
import { getUserAmpliProps } from '~entities/ampli/model/get-user-ampli-props';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';

import { DefaultPropsPlugin } from '../lib/default-props-plugin';

export const initAmpli = async () => {
  await ampli.load({
    client: {
      apiKey: config.amplitudeKey,
      configuration: {
        autocapture: false,
        appVersion: config.version,
      },
    },
    disabled: !config.isAmplitudeEnabled,
  }).promise;

  ampli.client.add(
    new DefaultPropsPlugin({
      defaultProps: {
        wuid: findOrCreateWuid(),
      },
      getDynamicProps: () => {
        return { ...getUserAmpliProps() };
      },
    })
  );

  ampli.client.setUserId(findOrCreateWuid());
};
